;(function($$){
	function Pixel(){
        this.px = {}
    }
    Pixel.prototype.set = function(param, value){
        if(value !== false){
            this.px[param] = value;
        }
        return this;
    }
    Pixel.prototype.send = function(event_name){
        fbq('track', event_name, this.px);
        //console.log('fbq:', event_name);
        //for(var n in this.px){
        //    console.log("\t- " + n + ':', this.px[n]);
        //}
        return this;
    }
    $$.Pixel = Pixel;
})(window)